<template>
  <details>
    <summary class="pointer b pt4 ph2 tc tl-l" data-posthog-action="calc:viewDetails">Itemized Costs:
    </summary>
    <table class="mt2">
      <tbody>
        <tr>
          <td class="b" width="30%">DNS Queries:</td>
          <td class="f3" width="40%">{{ state.queryBlocks }} * {{ currency(plan.price_per_query_block) }} *
            {{ state.roundedZones }}</td>
          <td>{{ currency(totals.queries) }}</td>
        </tr>

        <tr>
          <td class="b">DNS Zones:</td>
          <td class="f3">{{ state.roundedZones }} * {{ currency(plan.price_per_zone) }}</td>
          <td>{{ currency(totals.zones) }}</td>
        </tr>

        <tr v-if="plan.price_per_seat">
          <td class="b">Additional Seats:</td>
          <td class="f3">{{ state.purchasedSeats }} * {{ currency(plan.price_per_seat) }}</td>
          <td>{{ currency(totals.seats) }}</td>
        </tr>

        <tr v-if="plan.price">
          <td class="b">Subscription:</td>
          <td colspan="2">{{ currency(totals.subscription) }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="3" class="tr">
            <em class="mr4 f3">Total USD / month</em>
            <mark class="text-extra-bold">{{ currency(totals.sum) }}</mark>
          </td>
        </tr>
      </tfoot>
    </table>
  </details>
</template>

<script>
export default {
  name: 'PricingDetails',
  inject: ['state', 'currency'],

  props: {
    planId: { type: Number, required: true }
  },

  data () {
    return { plan: this.state.findPlanById(this.planId) };
  },

  computed: {
    totals () {
      return this.state.totalsForPlan(this.planId);
    }
  }

};
</script>

<style lang="scss" scoped>

@import "~/stylesheets/application/colors";

table {
  width: 100%;

  td {
    padding: .4em .6em;
    text-align: right;

    &.formula {
      font-size: .8em;
      font-style: italic;
      text-align: right;
    }
  }

  tbody {
    td {
      border: 2px solid white;
    }

    tr {
      background-color: $gray-100;
    }

    tr {
      &:nth-child(even) {
        background: $gray-200;
      }
    }
  }

}

</style>
